import styled from 'styled-components';
import { Card, Form } from 'react-bootstrap';

export const StyledLoginPage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url(https://pbs.twimg.com/media/EUh3CXvXsAYJ8Sm?format=jpg&name=4096x4096);
    background-size: cover;
    background-position: bottom;
    //expand content to fill screen
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    font-size: 14px;
`;
export const StyledLoginPageCard = styled(Card).attrs({ body: true })`
    width: 100%;
    max-width: 400px;
    min-height: 200px;
`;
export const StyledLoginForm = styled(Form)`
    > div {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        min-height: 160px;
    }
    .alert {
        margin-top: 10px;
    }
`;
